
namespace SorAraBul.PropertyManagement {
    export class PropertiesColumns {
        static columnsKey = 'PropertyManagement.Properties';
    }
}